var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRoute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ico_PWA_ruta_line_color",
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.788,
    height: 71.788,
    viewBox: "0 0 71.788 71.788",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16001",
    "data-name": "Grupo 16001",
    transform: "translate(1.402 1.402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76895",
    "data-name": "Trazado 76895",
    d: "M330.042,190.021a13.956,13.956,0,0,1-2.356,7.78l-11.666,18.3-11.666-18.3a14.022,14.022,0,1,1,25.687-7.78Zm-8.413,0a5.608,5.608,0,1,0-5.608,5.608A5.609,5.609,0,0,0,321.63,190.021Z",
    transform: "translate(-261.058 -152.725)",
    fill: "#7eccc9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_1513",
    "data-name": "Elipse 1513",
    cx: 2.597,
    cy: 3.116,
    rx: 2.597,
    ry: 3.116,
    transform: "translate(52.615 63.114)",
    fill: "#18a8a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76896",
    "data-name": "Trazado 76896",
    d: "M38.042,24.021a13.957,13.957,0,0,1-2.356,7.78L24.021,50.942,12.356,31.8a14.022,14.022,0,1,1,25.687-7.78Zm-8.413,0a5.608,5.608,0,1,0-5.608,5.608A5.609,5.609,0,0,0,29.63,24.021Z",
    transform: "translate(-10 -10)",
    fill: "#fce3ed"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_1514",
    "data-name": "Elipse 1514",
    cx: 2.597,
    cy: 3.116,
    rx: 2.597,
    ry: 3.116,
    transform: "translate(11.064 40.261)",
    fill: "#ee2b7c"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16002",
    "data-name": "Grupo 16002"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76897",
    "data-name": "Trazado 76897",
    d: "M13.284,41.528a4.205,4.205,0,1,0,6.1,5.022h10.9a4.206,4.206,0,0,1,0,8.413H13.46a7.011,7.011,0,1,0,0,14.021H27.481a1.4,1.4,0,1,0,0-2.8H13.46a4.206,4.206,0,1,1,0-8.413H30.286a7.011,7.011,0,0,0,0-14.021h-10.9a4.227,4.227,0,0,0-1.826-2.218L28.271,23.958a15.423,15.423,0,1,0-25.7,0Zm2.139,5.022a1.4,1.4,0,1,1,1.4-1.4A1.4,1.4,0,0,1,15.423,46.55Zm0-43.746a12.62,12.62,0,0,1,10.5,19.62l-.031.049L15.423,39.65S4.934,22.441,4.924,22.425A12.62,12.62,0,0,1,15.423,2.8Z",
    transform: "translate(0 0)",
    fill: "#3b0310"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76898",
    "data-name": "Trazado 76898",
    d: "M67.011,74.021A7.011,7.011,0,1,0,60,67.011,7.019,7.019,0,0,0,67.011,74.021Zm0-11.217A4.206,4.206,0,1,1,62.8,67.011,4.211,4.211,0,0,1,67.011,62.8Z",
    transform: "translate(-51.587 -51.587)",
    fill: "#f8b8d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76899",
    "data-name": "Trazado 76899",
    d: "M293.667,166a15.425,15.425,0,0,0-12.84,23.97L291.5,206.705a4.228,4.228,0,0,0-1.794,2.2H277.4a1.4,1.4,0,1,0,0,2.8h12.3a4.206,4.206,0,1,0,6.136-5l10.669-16.736A15.425,15.425,0,0,0,293.667,166Zm0,45.709a1.4,1.4,0,1,1,1.4-1.4A1.4,1.4,0,0,1,293.667,211.709Zm10.5-23.284-10.5,16.469-10.5-16.469a12.619,12.619,0,1,1,21,0Z",
    transform: "translate(-237.302 -142.725)",
    fill: "#3b0310"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76900",
    "data-name": "Trazado 76900",
    d: "M359.011,226a7.011,7.011,0,1,0,7.011,7.011A7.019,7.019,0,0,0,359.011,226Zm0,11.217a4.206,4.206,0,1,1,4.206-4.206A4.211,4.211,0,0,1,359.011,237.217Z",
    transform: "translate(-302.646 -194.312)",
    fill: "#18a8a2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_1515",
    "data-name": "Elipse 1515",
    cx: 1.558,
    cy: 1.039,
    rx: 1.558,
    ry: 1.039,
    transform: "translate(32.202 66.594)",
    fill: "#3b0310"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoute);
export default __webpack_public_path__ + "static/media/icon-route.166c10ea5491b1e21c033d39936565a1.svg";
export { ForwardRef as ReactComponent };